import {FlightVertical, FoodGrubhubVertical, ShopVertical} from '@/routeRegistry'

export const Vertical = {
  FoodGrubHub: 'FoodGrubHub',
  Shop: 'Shop',
  Flight: 'Flight',
  Account: 'Account',
} as const
export type Vertical = (typeof Vertical)[keyof typeof Vertical]

export default function useCurrentVertical(defaultVertical: Vertical): Vertical
export default function useCurrentVertical(): Vertical | undefined
export default function useCurrentVertical(defaultVertical?: Vertical) {
  const matches = useMatches()
  for (const match of matches) {
    switch (match.id) {
      case FoodGrubhubVertical.id:
        return Vertical.FoodGrubHub
      case ShopVertical.id:
        return Vertical.Shop
      case FlightVertical.id:
        return Vertical.Flight
      default:
    }
  }

  return defaultVertical
}
